<template lang="pug">
.container.grid-lg
  .card.mt-2
    .card-header
      .text-bold Filtrar
    .card-body
      form-filter(@submit="fetchReport")
  .full-height.loading.loading-lg(v-if="loading")
  div(v-else-if="report")
    div(v-if="showGrafico")
      .card.my-2.no-print
        .card-header
          .h5 Gráfico
        .card-body.chart-body
          line-chart(:data="chartData")
      card-group-data(:report="report", label-items="Meses")
    .card.mt-2(v-else)
      .card-body
        .empty
          .empty-icon
            i.fa.fa-search.fa-4x
          p.empty-title.h5 Nada encontrado
          p.empty-subtitle Não foram encontradas análises neste período
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import analises from "@/api/indicadores/analises"
import FormFilter from "./components/Filter"
import CardGroupData from "./components/CardGroupData"

const initialDate = new Date()
initialDate.setMonth(initialDate.getMonth() - 12)

export default {
  data() {
    return {
      loading: false,
      report: null,
    }
  },
  computed: {
    showGrafico() {
      return this.report.data && Object.values(this.report.data).length
    },
    chartData() {
      return Object.keys(this.report.data).map(name => ({
        name,
        data: this.report.data[name],
      }))
    },
  },
  components: { FormFilter, CardGroupData },
  methods: {
    async fetchReport(q = {}) {
      try {
        this.loading = true
        this.report = await analises.situacoesPorMeses({ q })
      } catch (error) {
        toastErrors(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchReport()
  },
}
</script>
